import { RecommendationsSettingsView } from 'components/RecommendationsSettingsView';

export const RecommendationsSettingsPage = (): JSX.Element => {
    return (
        <>
            <RecommendationsSettingsView></RecommendationsSettingsView>
        </>
    );
}